var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
import { SortableItem } from '../SortableItem/SortableItem';
import { SortableList } from '../SortableList/SortableList';
export class SortableEdit {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    addSortableItem() {
        const newSortableItem = SortableItem.fromSerialized({ parent: this.question });
        this.question.sortableStore.sortableItems.push(newSortableItem);
        newSortableItem.indexInDroppable = this.question.sortableStore.sortableLists[0].listItems.currentSortableItems.length;
        newSortableItem.droppableId = this.question.sortableStore.sortableLists[0].id_string;
    }
    removeSortableItem() {
        this.question.sortableStore.sortableItems[this.question.sortableStore.sortableItems.length - 1].itemEdit.removeSortableItem();
    }
    addSortableList() {
        this.question.sortableStore.sortableLists.push(SortableList.fromSerialized({ parent: this.question }));
    }
    removeSortableList() {
        if (this.question.sortableStore.sortableLists.length <= 1)
            return;
        this.question.sortableStore.sortableLists.pop();
    }
    fixInvalidItems() {
        const unassignedItems = this.question.sortableStore.sortableItems.filter((sortableItem) => !this.question.sortableStore.sortableLists.map((list) => list.id_string).includes(sortableItem.droppableId));
        unassignedItems.forEach((unassignedItem) => {
            unassignedItem.indexInDroppable = this.question.sortableStore.sortableLists[0].listItems.currentSortableItems.length;
            unassignedItem.droppableId = this.question.sortableStore.sortableLists[0].id_string;
        });
    }
}
__decorate([
    action.bound
], SortableEdit.prototype, "addSortableItem", null);
__decorate([
    action.bound
], SortableEdit.prototype, "removeSortableItem", null);
__decorate([
    action.bound
], SortableEdit.prototype, "addSortableList", null);
__decorate([
    action.bound
], SortableEdit.prototype, "removeSortableList", null);
__decorate([
    action.bound
], SortableEdit.prototype, "fixInvalidItems", null);
